import { useEffect, useState } from "react";
import { flushNextContactBlocks } from "./nextContactExitSave.mjs";

export default function NextContactExitDialog() {
  const [request, setRequest] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const receive = event => { setBusy(false); setRequest(event.detail); };
    const pending = event => { setBusy(true); setRequest(event.detail); };
    const settled = event => {
      setRequest(current => current?.operationId === event.detail?.operationId ? null : current);
    };
    const flush = () => { void flushNextContactBlocks(); };
    const timer = setInterval(flush, 30000);
    window.addEventListener("online", flush);
    flush();
    window.addEventListener("arflow:next-contact-failed", receive);
    window.addEventListener("arflow:next-contact-pending", pending);
    window.addEventListener("arflow:next-contact-settled", settled);
    return () => {
      window.removeEventListener("arflow:next-contact-failed", receive);
      window.removeEventListener("arflow:next-contact-pending", pending);
      window.removeEventListener("arflow:next-contact-settled", settled);
      window.removeEventListener("online", flush);
      clearInterval(timer);
    };
  }, []);
  if (!request) return null;
  return <div style={{ position:"fixed", inset:0, zIndex:10000, background:"#0007", display:"grid", placeItems:"center", padding:20 }}>
    <div role="alertdialog" aria-modal="true" aria-labelledby="next-contact-failure" style={{ background:"white", padding:24, borderRadius:14, maxWidth:420, color:"#2B1B12" }}>
      <h3 id="next-contact-failure">{request.retry ? "Não consegui salvar a data." : "Salvando a próxima data…"}</h3>
      <p>A saída continua disponível mesmo se a conexão falhar.</p>
      {request.retry && <button disabled={busy} onClick={async () => {
        setBusy(true);
        try { await request.retry(); setRequest(current => current?.operationId === request.operationId ? null : current); }
        catch { setBusy(false); }
      }} style={{ padding:12, marginRight:10 }}>{busy ? "Tentando…" : "Tentar de novo"}</button>}
      <button onClick={() => { request.leave(); setRequest(null); setBusy(false); }} style={{ padding:12 }}>Sair mesmo assim</button>
    </div>
  </div>;
}
